import {
  SAGE_50_BUSINESS_ID,
  SAGE_50_DATASOURCE_ID,
  SAGE_50_ORGANISATION_ID,
  SAGE_50_WORKSPACE_ID
} from '../storage/constants';
import { Storage } from '../storage/storage';

export const storeSage50Data = (businessId: string) => {
  const storage = Storage.getInstance();
  storage.set(SAGE_50_BUSINESS_ID, businessId);
};

export const getSage50Data = () => {
  const storage = Storage.getInstance();
  return storage.get(SAGE_50_BUSINESS_ID, '');
};

export const removeSage50Data = () => {
  const storage = Storage.getInstance();
  storage.remove(SAGE_50_BUSINESS_ID);
};

export const storeSage50OrgData = (workspaceId: string, organisationId: string, datasourceId: string) => {
  const storage = Storage.getInstance();
  storage.set(SAGE_50_WORKSPACE_ID, workspaceId);
  storage.set(SAGE_50_ORGANISATION_ID, organisationId);
  storage.set(SAGE_50_DATASOURCE_ID, datasourceId);
};

export const getSage50OrgData = () => {
  const storage = Storage.getInstance();
  return {
    workspaceId: storage.get(SAGE_50_WORKSPACE_ID, ''),
    organisationId: storage.get(SAGE_50_ORGANISATION_ID, ''),
    datasourceId: storage.get(SAGE_50_DATASOURCE_ID, '')
  };
};

export const removeSage50OrgData = () => {
  const storage = Storage.getInstance();
  storage.remove(SAGE_50_WORKSPACE_ID);
  storage.remove(SAGE_50_ORGANISATION_ID);
  storage.remove(SAGE_50_DATASOURCE_ID);
};
